/**
 * Initialize shared-components with iTeach configuration
 * This should be called once at app startup (in App.tsx or index.tsx)
 */
import { setGradeReportConfig } from '@conceptwaves/shared-components';
import Config from './config';

export function initializeSharedComponents() {
  // Configure grade reports module with iTeach's API URLs
  setGradeReportConfig({
    nodeSiteUrl: Config.nodeSiteUrl
  });

  console.log('[iTeach] Shared components initialized with config:', {
    nodeSiteUrl: Config.nodeSiteUrl
  });
}
